import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  recipientsParentContainer: {
    marginLeft: theme.spacing(4.125),
    flex: 1,
  },
  recipientsText: {
    textAlign: 'left',
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    paddingBottom: theme.spacing(1.5),
  },
  recipientsTextAndUpdateDateContainer: {
    borderBottom: `1px solid ${theme.palette.dividers.dark}`,
    gridTemplateColumns: '50% 50%',
    display: 'grid',
  },
  recipientsRow: {
    padding: theme.spacing(2, 0, 2, 0),
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    borderBottom: `1px dotted ${theme.palette.dividers.dark}`,
  },
  nameIconContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  accountIcon: {
    color: theme.palette.icon.main,
    '&.MuiSvgIcon-root': {
      fontSize: '24px',
      width: '1em',
      height: '1em',
      flexShrink: 0,
      fill: 'currentColor',
      userSelect: 'none',
    },
  },
  namesContainer: {
    marginLeft: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    wordBreak: 'break-all',
  },
  namesText: {
    fontSize: '14px',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
    textAlign: 'left',
  },
  emailsText: {
    color: theme.palette.detailedRecipientText.main,
    fontSize: '12px',
    textAlign: 'left',
  },
  recipientsStatus: {
    color: theme.palette.detailedRecipientText.main,
    fontSize: '12px',
    textAlign: 'left',
  },
  checkIcon: {
    color: theme.palette.opaque.dark,
    '&.MuiSvgIcon-root': {
      fontSize: '16px',
      width: '1em',
      height: '1em',
      flexShrink: 0,
      fill: 'currentColor',
      userSelect: 'none',
    },
    marginRight: theme.spacing(1),
  },
  status: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  statusTime: {
    fontSize: '12px',
    color: theme.palette.text.tertiary,
    marginLeft: theme.spacing(0.5),
  },
  queueStatus: {
    marginRight: theme.spacing(22),
  },
  sentAtStatus: {
    marginRight: theme.spacing(7.625),
  },
  updateRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
  },
  textField: {
    width: '211px',
    marginRight: theme.spacing(3),
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  closeIconButton: {
    padding: theme.spacing(0),
    margin: theme.spacing(-2.5, 0, -3, 0.187),
  },
  closeIcon: {
    '&.MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
      color: theme.palette.icon.main,
      fill: 'currentColor',
    },
  },
  recipientsRowsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  addButtonContainer: {
    margin: theme.spacing(3, 0, 0, 0),
    textAlign: 'left',
  },
  displayTooltipInAddButton: {
    display: 'inline-block',
  },
}))
